import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { SolarTypes } from "@/components/site/SolarTypes";
import { Categories } from "@/components/site/Categories";
import { PMSuryaGhar } from "@/components/site/PMSuryaGhar";
import { WhyUs } from "@/components/site/WhyUs";
import { Journey } from "@/components/site/Journey";
import { Brands } from "@/components/site/Brands";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative overflow-x-hidden bg-cream-50 text-slate-800">
      <div className="grain" />
      <Header />
      <main>
        <Hero />
        <SolarTypes />
        <Categories />
        <PMSuryaGhar />
        <WhyUs />
        <Journey />
        <Brands />
        <HowItWorks />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
